import React from 'react';
import ErrorBoundary from './error-boundary';
import $ from 'jquery';

export default class SubMenu extends React.Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {hideShow: ''}
  }

  componentDidMount () {
    const exists = (subMenu) => subMenu === this.props.data.id;
    let openMenu = this.props.selectedMenus.some(exists);

    if (openMenu) {
      this.setState({hideShow: 'active'});
    }
  }

  onSubMenuClick (e) {

    if ($(e.target).attr('class') === "menu_title" || $(e.target).is('img')){
      if (this.state.hideShow == '') {
          this.setState({hideShow: 'active'});
          this.props.updateSubMenu(this.props.data.id, true);

      }
      else {

        this.setState({hideShow: ''});
        this.props.updateSubMenu(this.props.data.id, false);

      }
    }

    setTimeout(()=>{
      window.resizeAllMasonryItems1();
    },100)


  }

  render() {
    const name = this.props.data.name;
    const masonary="grid-row-end: span 9";
    let imgPresentHeight = 0;


    const list = this.props.data.menus.map((menuItem)=>{
      return (
           <a className="menu_item" key={menuItem.id} href={this.props.lastHash + "/" + menuItem.id}>
            <span className="menu_item_holder">
              <span className="item_title_holder">
                <h4>{window.decodeHtml(menuItem.title)}</h4>
                <span className="icons">
                {menuItem.new ? <span class="new">New</span>: null }
                {menuItem.vegan ? <span class="vegan"><svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8V14C10.1217 14 12.1566 13.1571 13.6569 11.6569C15.1571 10.1566 16 8.12173 16 6V0C13.8783 0 11.8434 0.842855 10.3431 2.34315C8.84285 3.84344 8 5.87827 8 8Z" fill="#C7BE71"/><path d="M0 5V8C0 9.5913 0.632141 11.1174 1.75736 12.2426C2.88258 13.3679 4.4087 14 6 14V11C6 9.4087 5.36786 7.88258 4.24264 6.75736C3.11742 5.63214 1.5913 5 0 5H0Z" fill="#C7BE71"/></svg></span>: null }
                </span>
              </span>
                <span className="item_body_holder">
                  <span className="desc" dangerouslySetInnerHTML={{__html: menuItem.card_desc}} />
                  <span className="price" dangerouslySetInnerHTML={{__html: menuItem.price}} />
                </span>
            </span>
          </a>
        )
    });

    return (
      <div key={this.props.data.id} className="menu_item_wrap masonry-sub-menu">
  					<div className={"masonry-content " + this.state.hideShow} onClick={this.onSubMenuClick.bind(this)}>
  						<div className="menu_header">
  							<div className="menu_image">
  								<img src={this.props.data.image? this.props.data.image: ""} alt="" />
  							</div>
  							<div className="menu_title">
  								{window.decodeHtml(name)}
                  <span className="icon mobile_menu_toggle">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 0.999512L5 4.99951L9 0.999512" stroke="#fff" strokeWidth="0.996241" strokeLinecap="round" strokeLinejoin="bevel"></path>
                    </svg>
                  </span>
  							</div>
  						</div>
              <div className="menu_body">
              {list}
              </div>
  					</div>

  				</div>
    );
  }
}
//when adding the new image json
//<img src={this.props.data.image} alt="" />

//style="grid-row-end: span 9;"
//style="height: 90px;"
